import { isEmpty } from '@ember/utils';

// https://github.com/offirgolan/ember-validators/blob/v1.1.1/addon/format.js#L76
const EMAIL_REGEX =
  /^[a-z0-9!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.?)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i;

export default function isValidEmail(value: unknown) {
  // typeof check just to be extra safe, even though it shouldn't be needed:
  if (typeof value !== 'string') {
    return false;
  }

  return !isEmpty(value) && !isEmpty(value.match(EMAIL_REGEX));
}
